export default __webpack_public_path__ + "static/media/sidebar-2.c26842b9.jpg";